// Нижний лист «Добавить на главный экран» (HQ-772): один раз, на 3-й день визитов, только на корне вкладки и не в сессии,
// открытой по ссылке. Закрывается тапом по фону, «Не сейчас» и системной «Назад» — это dismissed; «Добавить» — accepted
// и штатное окно Telegram.
import { useEffect, useState } from 'react';
import { t } from '../i18n/i18n';
import { haptic } from '../telegram/webapp';
import { MaskIcon } from '../ui/Icon';
import sheetStyles from '../ui/Sheet.module.css';
import { useOverlayBack } from '../ui/useOverlayBack';
import deviceIcon from '../assets/icons/device-mobile.svg';
import { acceptHomeScreen, claimPrompt, dismissHomeScreen, recordVisit, useHomeScreenStatus, type PromptPlace } from './homeScreen';
import styles from './HomeScreenPrompt.module.css';

/** Ставится в оболочку приложения: отмечает день визита и, когда правило сходится, открывает лист. */
export function HomeScreenPrompt({ onTab, fromLink }: PromptPlace) {
  const [days] = useState(() => recordVisit());
  const status = useHomeScreenStatus();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open && claimPrompt({ status, days, onTab, fromLink })) setOpen(true);
  }, [open, status, days, onTab, fromLink]);
  if (!open) return null;
  return <HomeScreenSheet
    onAccept={() => { setOpen(false); acceptHomeScreen('auto'); }}
    onDismiss={() => { setOpen(false); dismissHomeScreen('auto'); }} />;
}

export function HomeScreenSheet({ onAccept, onDismiss }: { onAccept: () => void; onDismiss: () => void }) {
  useOverlayBack(onDismiss);
  return (
    <div className={sheetStyles.backdrop} onClick={onDismiss}>
      <div className={sheetStyles.sheet} onClick={(e) => e.stopPropagation()} role="dialog" aria-label={t('menu.home_screen.title')}>
        <div className={sheetStyles.grabber} />
        <div className={styles.body}>
          <span className={styles.icon}><MaskIcon src={deviceIcon} size={32} /></span>
          <div className={sheetStyles.title}>{t('menu.home_screen.title')}</div>
          <p className={styles.text}>{t('menu.home_screen.text')}</p>
          <button className={styles.primary} onClick={() => { haptic.impact('light'); onAccept(); }}>{t('menu.home_screen.add')}</button>
          <button className={styles.secondary} onClick={onDismiss}>{t('menu.home_screen.later')}</button>
        </div>
      </div>
    </div>
  );
}
